export const GET_PROJECT = 'GET_PROJECT';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';

export const RESET_PROJECT = 'RESET_PROJECT';
export const RESET_PROJECT_ENTITY_DATA = 'RESET_PROJECT_ENTITY_DATA';

export const DELETE_PROJECTS = 'DELETE_PROJECTS';
export const DELETE_PROJECTS_SUCCESS = 'DELETE_PROJECTS_SUCCESS';
export const DELETE_PROJECTS_ERROR = 'DELETE_PROJECTS_ERROR';

export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';

export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

export const BATCH_ADD_TO_PROJECT = 'BATCH_ADD_TO_PROJECT';
export const BATCH_ADD_TO_PROJECT_SUCCESS = 'BATCH_ADD_TO_PROJECT_SUCCESS';
export const BATCH_ADD_TO_PROJECT_ERROR = 'BATCH_ADD_TO_PROJECT_ERROR';

export const EDIT_PROJECT = 'EDIT_PROJECT';
export const EDIT_PROJECT_SUCCESS = 'EDIT_PROJECT_SUCCESS';
export const EDIT_PROJECT_ERROR = 'EDIT_PROJECT_ERROR';

export const SELECT_PROJECT_DETAILS_ITEM = 'SELECT_PROJECT_DETAILS_ITEM';
export const DESELECT_PROJECT_DETAILS_ITEM = 'DESELECT_PROJECT_DETAILS_ITEM';
export const RESET_PROJECT_DETAILS_ITEM = 'RESET_PROJECT_DETAILS_ITEM';

export const SELECT_PROJECT_DETAILS_SET = 'SELECT_PROJECT_DETAILS_SET';
export const DESELECT_PROJECT_DETAILS_SET = 'DESELECT_PROJECT_DETAILS_SET';
export const RESET_PROJECT_DETAILS_SET = 'RESET_PROJECT_DETAILS_SET';

export const SELECT_PROJECT_DETAILS_COLOR = 'SELECT_PROJECT_DETAILS_COLOR';
export const DESELECT_PROJECT_DETAILS_COLOR = 'DESELECT_PROJECT_DETAILS_COLOR';
export const RESET_PROJECT_DETAILS_COLOR = 'RESET_PROJECT_DETAILS_COLOR';

export const SELECT_PROJECT_DETAILS_IMAGE = 'SELECT_PROJECT_DETAILS_IMAGE';
export const DESELECT_PROJECT_DETAILS_IMAGE = 'DESELECT_PROJECT_DETAILS_IMAGE';
export const RESET_PROJECT_DETAILS_IMAGE = 'RESET_PROJECT_DETAILS_IMAGE';

export const BATCH_REMOVE_FROM_PROJECT = 'BATCH_REMOVE_FROM_PROJECT';
export const BATCH_REMOVE_FROM_PROJECT_SUCCESS = 'BATCH_REMOVE_FROM_PROJECT_SUCCESS';
export const BATCH_REMOVE_FROM_PROJECT_ERROR = 'BATCH_REMOVE_FROM_PROJECT_ERROR';
